import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Brand } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  constructor(private http: HttpClient) {}

  get() {
    return this.http.get<Brand[]>(`${API}brands`);
  }

  create(brand: Brand) {
    return this.http.post<Brand>(`${API}brands`, brand);
  }

  update(id, brand) {
    return this.http.put<Brand>(`${API}brands/${id}`, brand);
  }
}
